import React from 'react';
import { TGamesGridLayout } from 'js/hooks/games/types';

import { TGameRatio } from '../../types';

export const intersectionObserverHandler =
    (setIsRowVisible: React.Dispatch<React.SetStateAction<boolean>>) => (entries: IntersectionObserverEntry[]): void => {
        entries.forEach((entry: IntersectionObserverEntry) => {
            setIsRowVisible(entry.isIntersecting);
        });
    };

export const listToMatrix = <T>(list: T[], elementsPerSubArray: number): T[][] => {
    const matrix: T[][] = [];

    for (let i = 0, k = -1; i < list.length; i++) {
        if (i % elementsPerSubArray === 0) {
            k++;
            matrix[k] = [];
        }
        matrix[k].push(list[i]);
    }
    return matrix;
};

export const getGamesRatios = (categoryGameGridLayout?: TGamesGridLayout): { [key: string]: TGameRatio } => {
    const result: {[key: string]: TGameRatio} = {};
    const { layout, columns } = categoryGameGridLayout || {};

    if (!layout || columns === undefined) {
        return result;
    }

    const cleanLayout = layout
        .replace(/"/g, '')
        .replace(/\//g, '');

    const matrix = listToMatrix(cleanLayout.split(' '), Number(columns));

    matrix.forEach((row, i) => {
        row.forEach((cell, j) => {
            if (result[cell]) {
                return;
            }

            const currentPosition = [1, 1];

            if (matrix[i + 1]?.[j] === cell) {
                currentPosition[1] += 1;
            }

            if (matrix[i][j + 1] === cell) {
                currentPosition[0] += 1;
            }

            result[cell] = `layout${currentPosition[0]}x${currentPosition[1]}` as TGameRatio;
        });
    });

    return result;
};
